export default {
    "'dependencies'": 'Falta el campo dependencias.'
}